import { render, staticRenderFns } from "./wtsHistory.vue?vue&type=template&id=40731edb&scoped=true"
import script from "./wtsHistory.vue?vue&type=script&lang=js"
export * from "./wtsHistory.vue?vue&type=script&lang=js"
import style0 from "./wtsHistory.vue?vue&type=style&index=0&id=40731edb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40731edb",
  null
  
)

export default component.exports